import React, { AriaAttributes, memo } from 'react';
import { cx } from 'linaria';
import { suggestionsFieldset, suggestionsWrapper } from './suggestion-list-styles';

type SuggestionsListProps = React.PropsWithChildren<{
  dividers?: boolean;
  suggestionSelector: string;
  'data-qa': string;
}> &
  AriaAttributes;

export const SuggestionsList: React.FC<SuggestionsListProps> = memo((props) => {
  const { suggestionSelector, 'aria-label': label, children, dividers = false, 'data-qa': dataQA } = props;
  const count = React.Children.count(children);

  if (count === 0) return null;

  return (
    <div className={cx(suggestionsWrapper, suggestionSelector, dividers && 'dividers')}>
      <fieldset aria-label={label} className={cx(suggestionsFieldset, suggestionSelector)} data-qa={dataQA}>
        {children}
      </fieldset>
    </div>
  );
});
